import React from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import WorkplaceCalendar from '../../../../Components/Calendar/WorkplaceCalendar';

interface Props {
	eventId: string;
	patientId: string;
}

const CalendarEventDetail: React.FC<Props> = ({ eventId, patientId }) => {
	const { workplaceId } = useAppContext();

	return (
		<WorkplaceCalendar
			workplaceId={workplaceId}
			patientId={patientId}
			params={{ eventId, autoOpen: true }}
		/>
	);
};

export default CalendarEventDetail;
